module.exports = __webpack_public_path__ + "static/media/dbsp0oh-e289d163-38a4-49e5-ab3b-9cbe8babe040.4b0b199e.png";